module.exports = "<table-component columns=\"vm.tab.columns\" options=\"vm.options\" data=\"vm.data\" ></table-component>\n"


//////////////////
// WEBPACK FOOTER
// ./app/components/sourceTable/sourceTable.html
// module id = 497
// module chunks = 1